import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useContentStudioEnabled = (): boolean =>
  useBooleanFlagValue('content_studio_mvp', false);
